import React from "react";
import { Line } from "react-chartjs-2";
import { comma } from "../../helpers/common.functions";
import isEmpty from "../../validation/is-empty";

export default function CashflowGraph(props) {
  const { data } = props;

  if (isEmpty(data)) {
    return null;
  }

  // Take all cost plans for this project
  let field = [];
  let value = [];
  let value2 = [];

  !isEmpty(data) &&
    data.forEach((d) => {
      field.push(d["date"]);
      value.push(d["forecastCumulative"]);
      value2.push(d["forecastMonthly"]);
    });

  // Create the graph object
  let graph = {
    labels: field,
    datasets: [
      {
        yAxisID: "forecastCumulative",
        label: "Cumulative Cashflow",
        data: value,
        barThickness: 10,
        borderColor: `rgba(228, 97, 15,1)`,
        backgroundColor: `rgba(228, 97, 15,1)`,
        lineTension: 0,
        fill: false,
      },
      {
        yAxisID: "monthlyCost",
        label: "Monthly Cost",
        data: value2,
        barThickness: 10,
        borderColor: `rgba(50, 98, 149,1)`,
        backgroundColor: `rgba(50, 98, 149,1)`,
        lineTension: 0,
        type: "bar",
        fill: false,
      },
    ],
    text: field,
  };

  // Create the options object
  let options = {
    animation: {
      duration: 3000,
    },
    maintainAspectRatio: false,
    plugins: { datalabels: { display: false } },

    tooltips: {
      enabled: true,
      callbacks: {
        label: function (tooltipItem) {
          return comma(Math.round(tooltipItem.yLabel));
        },
      },
    },

    scales: {
      xAxes: [
        {
          stacked: false,
        },
      ],
      yAxes: [
        {
          id: "forecastCumulative",
          scaleLabel: {
            display: true,
            labelString: "Cumulative Cashflow",
          },
          position: "left",
          stacked: false,
          ticks: {
            callback: function (tick, index, values) {
              return comma(Math.round(tick));
            },
            min: 0,
          },
        },
        {
          id: "monthlyCost",
          scaleLabel: {
            display: true,
            labelString: "Monthly Cost",
          },
          position: "right",
          stacked: false,
          ticks: {
            callback: function (tick, index, values) {
              return comma(Math.round(tick));
            },
            min: 0,
          },
        },
      ],
    },
    legend: {
      display: true,
      position: "bottom",
      fullWidth: true,
      reverse: false,
    },
  };
  return (
    <div className="cashflow-container">
      <h1
        className="display-4"
        style={{ fontSize: "20px", marginBottom: "20px" }}
      >
        Cashflow Forecast
      </h1>
      <Line data={graph} options={options} />
    </div>
  );
}
